module.exports = __webpack_public_path__ + "static/media/ico-back-large.a3de66ee.svg";